/**
 * ============================================================================
 * D4F HOW IT WORKS - SCROLL ANIMATIONS
 * Optional: Animiert Steps beim Scrollen in den Viewport
 * ============================================================================
 */
(function () {
  'use strict';

  const section = document.querySelector('.d4f-how-it-works');
  if (!section) return;

  // Intersection Observer für Scroll-Animationen
  const observerOptions = {
    threshold: 0.2,
    rootMargin: '0px 0px -100px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, observerOptions);

  // Beobachte alle Steps
  const steps = section.querySelectorAll('.d4f-how-it-works__step');
  steps.forEach(step => {
    observer.observe(step);
  });

  console.log('[D4F How It Works] Initialized with', steps.length, 'steps');
})();